import { render, staticRenderFns } from "./PrivilegeForm.vue?vue&type=template&id=4e56af48&scoped=true&"
import script from "./PrivilegeForm.vue?vue&type=script&lang=js&"
export * from "./PrivilegeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e56af48",
  null
  
)

export default component.exports